<div class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
  <div class="bg-white rounded-[2rem] w-full max-w-2xl shadow-2xl overflow-hidden flex flex-col max-h-[calc(100dvh-2rem)]">

    <!-- Header -->
    <div class="flex items-center justify-between gap-3 px-6 py-4 border-b border-dark-text/8">
      <!-- min-w-0 + truncate: a long camera file name in the title
           ("Edit PXL_20260914_183022123.jpg (2 to go)") used to push the
           close button out of the card. -->
      <div class="min-w-0">
        <span class="text-trinidad font-label uppercase tracking-[0.14em] text-[0.65rem] font-bold block">Photo editor</span>
        <h2 class="font-headline font-bold text-dark-text text-xl leading-tight truncate" [title]="title">{{ title }}</h2>
      </div>
      <button type="button" (click)="cancel()" aria-label="Close editor"
        class="shrink-0 w-11 h-11 rounded-full hover:bg-cream/60 flex items-center justify-center transition-colors">
        <span class="material-symbols-outlined text-dark-text">close</span>
      </button>
    </div>

    <!-- Cropper viewport -->
    <div class="relative flex-1 min-h-0 bg-black/5 flex items-center justify-center overflow-hidden">
      @if (!loaded && !failed) {
        <div class="absolute inset-0 flex flex-col items-center justify-center gap-2 text-muted-text pointer-events-none" role="status">
          <span aria-hidden="true" class="material-symbols-outlined text-3xl animate-spin">progress_activity</span>
          <span class="text-sm font-body">Opening photo…</span>
        </div>
      }
      @if (failed) {
        <div class="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center bg-cream" role="alert">
          <span aria-hidden="true" class="material-symbols-outlined text-3xl text-trinidad">broken_image</span>
          <p class="text-sm font-body text-dark-text">Couldn't open this photo. Try a JPEG or PNG.</p>
          <button type="button" (click)="cancel()"
            class="min-h-[44px] px-5 rounded-full border border-dark-text/15 bg-white text-dark-text text-xs uppercase tracking-[0.12em] font-button font-bold">
            Skip this photo
          </button>
        </div>
      }
      <image-cropper
        class="h-full w-full max-w-full"
        [imageFile]="sourceFile ?? undefined"
        [imageURL]="sourceDataUrl ?? undefined"
        [aspectRatio]="aspectRatio"
        [maintainAspectRatio]="true"
        [transform]="{ rotate: rotation }"
        [containWithinAspectRatio]="false"
        format="jpeg"
        backgroundColor="#f7f5ec"
        (imageCropped)="onCropped($event)"
        (imageLoaded)="onImageLoaded($event)"
        (loadImageFailed)="onLoadFailed()">
      </image-cropper>
    </div>

    @if (queueRemaining > 0) {
      <!-- Multi-photo pick: skip cropping the rest, or stop adding. -->
      <div class="px-6 py-3 border-t border-dark-text/8 bg-cream/50 flex flex-wrap items-center gap-2">
        <span class="basis-full sm:basis-auto text-sm font-body text-dark-text sm:mr-auto">
          {{ queueRemaining }} more {{ queueRemaining === 1 ? 'photo' : 'photos' }} after this one
        </span>
        <button type="button" (click)="stopQueue.emit()"
          class="flex-1 sm:flex-initial min-h-[44px] px-4 rounded-full text-xs uppercase tracking-[0.12em] font-button font-bold text-dark-text/70 hover:text-dark-text">
          Stop adding
        </button>
        <button type="button" (click)="useRestAsIs.emit()"
          class="flex-1 sm:flex-initial min-h-[44px] px-4 rounded-full border border-jungle-green/40 bg-white text-jungle-green text-xs uppercase tracking-[0.12em] font-button font-bold hover:bg-jungle-green/10">
          Add all as-is
        </button>
      </div>
    }

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-dark-text/8 flex items-center justify-between gap-3 flex-wrap">

      <!-- Rotate controls -->
      <div class="flex items-center gap-2">
        <button type="button" (click)="rotateLeft()" aria-label="Rotate left"
          class="inline-flex items-center justify-center gap-2 min-h-[44px] min-w-[44px] px-3 sm:px-4 rounded-lg border border-dark-text/15 bg-cream/50 hover:bg-cream text-dark-text font-body text-sm transition-colors">
          <span aria-hidden="true" class="material-symbols-outlined text-base">rotate_left</span>
          <span class="hidden sm:inline">Rotate left</span>
        </button>
        <button type="button" (click)="rotateRight()" aria-label="Rotate right"
          class="inline-flex items-center justify-center gap-2 min-h-[44px] min-w-[44px] px-3 sm:px-4 rounded-lg border border-dark-text/15 bg-cream/50 hover:bg-cream text-dark-text font-body text-sm transition-colors">
          <span aria-hidden="true" class="material-symbols-outlined text-base">rotate_right</span>
          <span class="hidden sm:inline">Rotate right</span>
        </button>
      </div>

      <!-- Cancel + Save -->
      <div class="flex items-center gap-2 ml-auto">
        <button type="button" (click)="cancel()"
          class="min-h-[44px] px-5 rounded-full font-button font-bold text-xs uppercase tracking-widest text-dark-text/70 hover:text-dark-text transition-colors">
          Cancel
        </button>
        <button type="button" (click)="save()" [disabled]="!loaded"
          class="min-h-[44px] px-6 rounded-full bg-trinidad text-white font-button font-bold text-xs uppercase tracking-widest hover:brightness-110 transition-[filter] disabled:opacity-50 disabled:cursor-not-allowed">
          Save photo
        </button>
      </div>

    </div>

  </div>
</div>
